import React from 'react';
import RestBanner from '../rest-banner/RestBanner';
import axios from 'axios'
import './app.project.scss';

function OurProject(props) {
    return (
      <>
        <RestBanner heading="PROJECTS" img={'./project_rest.jpg'}/>
        <section id="rest-projects">
          <div className="rest-projects container">
              {/* <div className="rest-projects-gallery">
                  {props.OurProject && props.OurProject.map((OurProject, index) => (
                    <div className="rest-projects-item">
                      <div className='item-inner'>
                        <h2>{OurProject.projectTitle}</h2>
                        <div className='img-wrap'>
                          <img src={OurProject.img} alt="img"/>
                        </div>
                        <p>{OurProject.projectDetail}</p>
                      </div>
                    </div>
                  ))}
              </div> */}
            <div dangerouslySetInnerHTML={{__html: props.projectData.rendered}}></div>
          </div>
        </section>
      </>
    )
}

export default OurProject;
